export default __webpack_public_path__ + "8be67be6ef52299c2141d3b7fd855c20.png";